import React, { useEffect, useState, memo } from "react";
import { FaRegCalendarAlt } from "react-icons/fa";
import { FaEye } from "react-icons/fa";
import { BiSolidMoviePlay } from "react-icons/bi";
import "./ClipsList.css";

function formatDate(iso) {
  if (!iso) return "—";
  return new Intl.DateTimeFormat(undefined, {
    year: "numeric", month: "short", day: "numeric"
  }).format(new Date(iso));
}

function formatViews(n) {
  if (n == null) return "—";
  return n.toLocaleString();
}

function ClipsListInner() {
  const [clips, setClips] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const endpoint = process.env.REACT_APP_TWITCH_CLIPS_ENDPOINT || "/api/twitch/clips";

  useEffect(() => {
    const controller = new AbortController();
    let didMount = true;

    async function load() {
      try {
        const res = await fetch(endpoint, { signal: controller.signal });
        if (!res.ok) {
          if (!didMount) return;
          setError("Failed to load clips");
          setLoading(false);
          return;
        }
        const data = await res.json();
        if (!didMount) return;
        setClips(data.clips || []);
        setLoading(false);
      } catch (err) {
        if (!didMount) return;
        if (err.name === "AbortError") {
          return;
        }
        setError(String(err));
        setLoading(false);
      }
    }

    load();

    return () => {
      didMount = false;
      controller.abort();
    };
  }, [endpoint]);

  if (loading) {
    return (
      <div className="clips-list">
        <div className="clip-placeholder">A carregar clips…</div>
      </div>
    );
  }

  if (error || !clips.length) {
    return (
      <div className="clips-list">
        <div className="clip-placeholder">Sem clips disponíveis</div>
      </div>
    );
  }

  return (
    <div className="clips-list">
      <div className="clips-grid">
        {clips.map((c) => (
          <a key={c.id} className="clip-card" href={c.url} target="_blank" rel="noopener noreferrer">
            <div className="clip-thumb">
              <img
                src={c.thumbnail_url}
                alt={c.title}
                className="clip-thumbnail-img"
                loading="lazy"
                decoding="async"
              />
              <div className="play-icon-overlay" aria-hidden="true" />
              <div className="clip-views-badge">
                <FaEye />
                <span>{formatViews(c.view_count)}</span>
              </div>
            </div>

            <div className="clip-body">
              <div className="clip-title">{c.title}</div>

              <div className="clip-meta">
                <div className="clip-meta-row">
                  <div className="clip-meta-item">
                    <FaRegCalendarAlt className="clip-meta-icon" />
                    <span>{formatDate(c.created_at)}</span>
                  </div>
                </div>

                <div className="clip-author">
                  <BiSolidMoviePlay className="clip-meta-icon" />
                  <span>Clippado por {c.creator_name}</span>
                </div>
              </div>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}

export default memo(ClipsListInner);
